import {
  Image, Typography, VertButton, VertModal,
} from '@vertem-core/vertice-ds';
import GiftModalIcon from 'Assets/images/GiftModalIcon';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { participantAlreadySawInformativeModal } from 'redux/Reducers/Gift/GiftSlice';

const GiftInformativeModal = ({ isOpen, onCancel }) => {
  const dispatch = useDispatch();

  return (
    <VertModal
      onCancel={() => {
        onCancel();
        // dispatch(participantAlreadySawInformativeModal());
      }}
      open={isOpen}
      centered
      closable
      footer={(
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            padding: '0 27px',
          }}
        >
          <Link className="col-12" to="/gift">
            <VertButton type="highlight" className="col-12">
              <Typography.Text
                style={{
                  fontSize: '16px', lineHeight: '24px', color: 'white', fontWeight: 'regular',
                }}
                strong
              >
                Resgatar meu brinde!
              </Typography.Text>
            </VertButton>
          </Link>
        </div>
      )}

      zIndex={1000}
    >
      <div style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        padding: '0 27px',
      }}
      >
        <GiftModalIcon />
        <Typography.Text
          style={{ fontSize: '18px', lineHeight: '28px', marginTop: '24px', textAlign: 'center' }}
          strong
        >
          Parabéns, você ganhou um brinde!
        </Typography.Text>
        <Typography.Text
          style={{
            textAlign: 'center',
            marginTop: '15px',
            fontSize: '14px',
            lineHeight: '20px',
          }}
        >
          Resgate agora mesmo seu brinde de boas vindas e aproveite nossos produtos e serviços!
        </Typography.Text>
      </div>
    </VertModal>
  );
};

export default GiftInformativeModal;
